module.exports = __webpack_public_path__ + "static/media/thumbs-down.16599281.svg";